var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtoken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 60,
    viewBox: "0 0 162 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5616 38.0959C97.4744 38.0959 99.8356 35.7346 99.8356 32.8219C99.8356 29.9092 97.4744 27.5479 94.5616 27.5479C91.6489 27.5479 89.2877 29.9092 89.2877 32.8219C89.2877 35.7346 91.6489 38.0959 94.5616 38.0959ZM94.5616 35.8356C95.81 35.8356 96.8219 34.4864 96.8219 32.8219C96.8219 31.1575 95.81 29.8082 94.5616 29.8082C93.3133 29.8082 92.3014 31.1575 92.3014 32.8219C92.3014 34.4864 93.3133 35.8356 94.5616 35.8356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 42.9932H30.5205L41.2568 21.3322L39.1849 17L26 42.9932Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1849 35.2705L35.0411 42.9932H43.3288L39.1849 35.2705Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4452 30.1849L47.8493 42.9932H52.3699L43.7055 26.0411L41.4452 30.1849Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2808 37.9075H63.8596L64.9897 34.7055H70.0753L71.2055 37.9075H74.5959L69.6986 24.1575H65.9315L60.2808 37.9075ZM65.5548 32.4452H69.6986L67.8151 26.4178L65.5548 32.4452Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.726 26.4178V23.9692H88.1575V26.4178H83.2603V37.9075H80.2466V26.4178H75.726Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.096 23.2158V37.9075H104.545V35.4589L106.24 33.7637L109.065 37.9075H112.644L108.688 31.8801L112.644 28.113H108.877L104.545 32.4452V23.2158H102.096Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.86 27.7363C114.339 27.7363 113.334 31.3779 113.397 33.1986C113.397 35.4589 115.243 38.0959 118.86 38.0959C122.476 38.0959 124.008 36.0868 124.322 35.0822H121.12C121.057 35.4589 120.517 36.2123 118.86 36.2123C117.202 36.2123 116.537 34.5799 116.411 33.7637H124.322V32.6336C124.385 31.0011 123.38 27.7363 118.86 27.7363ZM119.048 29.8082C117.089 29.8082 116.599 31.1895 116.599 31.8801H121.497C121.497 31.1895 121.007 29.8082 119.048 29.8082Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.205 27.9247V37.7192H129.219V31.5034C129.219 30.9384 129.671 29.8082 131.479 29.8082C131.982 29.8082 132.986 30.2979 132.986 32.2568V37.7192H136V29.8082C136 29.0548 135.397 27.5479 132.986 27.5479C130.575 27.5479 129.47 28.8037 129.219 29.4315V27.9247H126.205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtoken);
export default __webpack_public_path__ + "static/media/atoken.a5b3d0c999ee0a9465ac636962953ced.svg";
export { ForwardRef as ReactComponent };